import AppForm from '@/components/AppForm';
import AppPageTitle from '@/components/AppPageTitle';
import { Checkbox, Col, Form, Input, Row } from 'antd';
import React from 'react';

function TopicConfig() {
  return (
    <div>
      <AppPageTitle title="Configuration" />
      <AppForm hasButtons={false}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Config key"
              name="config_key"
              rules={[{ message: 'Please enter config key' }]}
            >
              <Input placeholder="Enter config key" />
            </Form.Item>

            <Form.Item
              label="Config value My"
              name="config_value_my"
              rules={[{ message: 'Please enter config value my' }]}
            >
              <Input placeholder="Enter full word Myanmar" />
            </Form.Item>

            <Form.Item
              label="Description"
              name="description"
              rules={[{ message: 'Please enter full word Myanmar' }]}
            >
              <Input.TextArea placeholder="Description" className="!min-h-[100px]" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Config Value"
              name="config_value"
              rules={[{ message: 'Enter config value' }]}
            >
              <Input placeholder="Enter config value" />
            </Form.Item>

            <Form.Item label="Group name" name="group_name">
              <Input placeholder="Enter group name" />
            </Form.Item>
            <Form.Item name="active" valuePropName="checked">
              <Checkbox>Active</Checkbox>
            </Form.Item>
          </Col>
        </Row>
      </AppForm>
    </div>
  );
}

export default TopicConfig;
